import { render } from "./PFaceOldQRLink.vue?vue&type=template&id=a3e7af06"
import script from "./PFaceOldQRLink.vue?vue&type=script&lang=js"
export * from "./PFaceOldQRLink.vue?vue&type=script&lang=js"

import "./PFaceOldQRLink.vue?vue&type=style&index=0&id=a3e7af06&lang=scss"
script.render = render

export default script